export default __webpack_public_path__ + "static/media/bicicleta_de_man_en_verde.1efdccdf.jpg";